/**
 * @generated SignedSource<<3b909e0fbf848c77e70b2e61055569ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateLabelInput = {
  name?: string | null;
};
export type LabelEditFormMutation$variables = {
  id: string;
  input: UpdateLabelInput;
};
export type LabelEditFormMutation$data = {
  readonly updateLabel: {
    readonly " $fragmentSpreads": FragmentRefs<"LabelEditForm_label" | "LabelSidebar_label">;
  };
};
export type LabelEditFormMutation = {
  response: LabelEditFormMutation$data;
  variables: LabelEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LabelEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "updateLabel",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LabelSidebar_label"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LabelEditForm_label"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LabelEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "updateLabel",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4c91a5704c7bf4d224067f7ef813bdc3",
    "id": null,
    "metadata": {},
    "name": "LabelEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation LabelEditFormMutation(\n  $id: ID!\n  $input: UpdateLabelInput!\n) {\n  updateLabel(id: $id, input: $input) {\n    ...LabelSidebar_label\n    ...LabelEditForm_label\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment LabelEditForm_label on Label {\n  id\n  name\n}\n\nfragment LabelSidebar_label on Label {\n  ...EntitySidebar_entity\n}\n"
  }
};
})();

(node as any).hash = "cfbb328c07dd874eea468a34a5c47dd4";

export default node;
